import styled, { css } from "styled-components/macro";
import { PrimaryButton, InputSwitch, SecondaryButton } from "@loanbossinc/component-library";

export const WideStyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    font-size: 13px;
    margin-left: 1em;
    white-space: nowrap;
    width: 170px !important;

    &:hover {
      background: #005aa9 !important;
    }
  }
`;

export const InfoWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #dadce0;
    padding: 0.5em 1em;
    box-sizing: border-box;
  }
`;

export const LeftContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const NameTypeWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const NameWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
  }
`;

export const TypeWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const RightContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 0 1em;
    text-align: right;
  }
`;

export const LevelWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 500;
    padding-right: 1em;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CalculationWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 88px;
    border-bottom: 1px solid #dadce0;
    padding: 0.5em 1em 0.5em 0.5em;
    box-sizing: border-box;
  }
`;

export const NameDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 1.5em;
`;

export const DataAsOfDate = styled.div`
  padding-bottom: 5px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: semi-bold;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
`;

export const UploadDate = styled.div`
  padding-bottom: 5px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
`;

export const StyledLockedSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

export const LeftCalculationSection = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-content: space-between;
  height: 100%;
`;

export const PreviewResult = styled.div`
  min-width: 170px;
  padding: 0 1em;
  height: 45px;
  background: #fafafa;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  & .MuiFormControlLabel-labelPlacementStart {
    margin-left: 0 !important;
  }
`;
export const AnnualizedText = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  padding-left: 0.7em;
`;

export const CellsAmount = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  padding-top: 0.5em;
  padding-left: 4.9em;
`;

export const GridWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  & .react-grid-Container {
    box-sizing: border-box !important;
  }
  & .react-grid-Grid {
    border: none !important;
    min-height: calc(100vh - 265px) !important;
  }
  & .react-grid-Header {
    background: none !important;
  }
  & .react-grid-Cell {
    box-sizing: border-box !important;
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 130%;
  }
  & .react-grid-HeaderCell {
    box-sizing: border-box !important;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
  }

  & .rdg-selected {
    border: none !important;
  }

  & div.react-grid-Row div.react-grid-Cell {
    padding-left: 0px;
    padding-right: 0px;
    line-height: 2.1;
    text-align: center;
  }

  & .row-selected {
    & .react-grid-Cell {
      color: #000000;
      background: #ffffff;
      font-weight: 500 !important;
    }
    & .react-grid-Row:hover {
      .react-grid-Cell {
        background: #ffffff !important;
      }
    }
  }

  & .row-selected.not-bold {
    & .react-grid-Cell {
      font-weight: normal !important;
    }
  }

  & .row-not-selected {
    & .react-grid-Cell {
      color: #000000;
      background: #f8f8f8;
    }
    & .react-grid-Row:hover {
      & .react-grid-Cell {
        background: #f8f8f8 !important;
      }
    }
  }
`;

export const CustomRowContainer = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  height: 55px;
  width: 100%;
`;

const selectedLeftCell = css`
  background: #0f9ad6;
  color: #ffffff;
  border-radius: 16px 0px 0px 16px;
  border-right: none;
`;

const selectedRightCell = css`
  background: #0f9ad6;
  color: #ffffff;
  border-radius: 0px 16px 16px 0px;
  border-left: none;
  border-right: 1px solid #f0f0f0;
`;

const cellsBetweenAnchors = css`
  border-top: 2px solid #0f9ad6;
  border-bottom: 2px solid #0f9ad6;
  box-sizing: border-box;
`;

export const StyledCustomCell = styled.div`
  font-weight: ${props => (props.colIdx === 0 ? "500" : "normal")};
  box-sizing: border-box;
  font-family: Work Sans;
  font-style: normal;
  font-size: 14px;
  line-height: 130%;
`;

export const StyledCustomCellWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  width: ${props => `${props.width}px`};
  height: 100%;
  ${props => {
    if (props.colIdx === props.anchorCol) {
      return props.dataSelectDirection === "ltr" ? selectedLeftCell : selectedRightCell;
    } else if (props.colIdx === props.colIndexSelected) {
      return props.dataSelectDirection === "ltr" ? selectedRightCell : selectedLeftCell;
    } else if (props.colIndexSelected !== null) {
      if (
        (props.colIdx > props.anchorCol && props.colIdx < props.colIndexSelected && props.dataSelectDirection === "ltr") ||
        (props.colIdx < props.anchorCol && props.colIdx > props.colIndexSelected && props.dataSelectDirection === "rtl")
      ) {
        return cellsBetweenAnchors;
      }
    }

    return "";
  }}
`;

export const RangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -1em;
`;

export const RangeSelectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dadce0;
  padding: 1em;
`;

export const NavigationWrapper = styled.div`
  display: flex;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CellsSelected = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  color: #5f6368;
`;

export const PaddedWrapper = styled.div`
  padding-left: 1em;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    background: #ffffff;
    color: #005aa9;
    border: 1px solid #005aa9;
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    &:disabled {
      background: #c4c4c4 !important;
    }
    &:hover {
      background: #004d91;
    }
  }
`;

export const SearchAndFileWrapper = styled.div`
  display: flex;
  padding: 1em;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dadce0;
`;

export const StyledNameDateWrapper = styled(NameDateWrapper)`
  padding: 0;
  padding-left: 2em;
  width: 350px;
  align-items: flex-end;
`;
